import React, { useEffect } from 'react';
import { clearLastPath, getParameterByName, toQueryString } from '@shared/utils/UrlUtils';
import AuthWrapper from '../auth/components/AuthWrapper';
import { microsoftClientId } from '@shared/services/EnvironmentVariables';
import { authentication } from "@microsoft/teams-js";
import { v4 as uuidv4 } from 'uuid';

export default function LoginWithAdminConsent() {
  useEffect(() => {
    document.body.style.backgroundColor = '#FAFAFA';
    clearLastPath();
  }, []);

  useEffect(() => {
    if (!authentication) {
      window.close();
      return;
    }

    const scopes = getParameterByName('scopes', window.location.href);
    const state = uuidv4();
    localStorage.setItem('adminConsent.state', state);

    // The admin consent endpoint returns ?admin_consent=True&tenant=...&state=...
    // — not tokens. The end page handles that response.
    const queryParams = {
      client_id: microsoftClientId,
      scope: scopes,
      redirect_uri: window.location.origin + '/login/admin-consent-end',
      state: state,
    };

    const url = `https://login.microsoftonline.com/common/v2.0/adminconsent?${toQueryString(queryParams)}`;
    window.location.assign(url);
  }, []);

  return (
    <AuthWrapper dataTest="admin-consent" title="" spinner={true} hideLoginLink={true} hideHeader={true}>
    </AuthWrapper>
  );
}
